module.exports = __webpack_public_path__ + "img/flag-ES.69bf7c3d.png";